<div class="chart-host-overlay">
  <app-spinner-overlay
    [visible]="loading"
    [label]="loadingLabel"
  />
  <div #chartHost class="chart-host-overlay__surface" [attr.aria-label]="ariaLabel"></div>
</div>
